/**
 * Whether product cards should open in a new tab: only on devices whose
 * primary pointer is a mouse (hover + fine pointer). Touch phones and tablets
 * (iPadOS included) navigate in the same tab. Hydration-safe: `false` in SSR
 * and during hydration, so the card's `target` attribute always matches the
 * server render.
 */
export const useOpenInNewTab = () =>
  useHydrationSafeMediaQuery('(hover: hover) and (pointer: fine)')
